import { useState } from "react";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import { alpha } from "@mui/material/styles";
import StyledMenu from "../shared/optionMenu/StyledMenu";
import { GrSearch, GrSearchAdvanced } from "react-icons/gr";
import { useSelector } from "react-redux";
import COLORS from "../styles/COLORS";

// const primaryColor = "#00aa7e";
const primaryColor = COLORS.blue ;

export default function SearchItemBtnGrp(props) {
  const { onSrchItemClicked, disabled } = props;
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const commercialProducts = useSelector(
    (state) => state.ctrl.commercialProducts
  );
  const handleMenuItemClick = (_, index) => {
    onSrchItemClicked(commercialProducts[index]);
    handleClose();
  };

  // Toggle dropdown visibility
  const handleToggle = (event) => {
    setOpen(!open);
    setAnchorEl(event.currentTarget);
  };

  // Close dropdown
  const handleClose = () => {
    setOpen(false);
    setAnchorEl(null);
  };

  return (
    <>
      <div style={{ display: "flex", gap: "8px" }}>
        <Button
          variant="contained"          
          size="small"
          aria-controls={open ? "split-button-menu" : undefined}
          aria-expanded={open ? "true" : undefined}
          aria-label="Add new item"
          aria-haspopup="menu"
          onClick={handleToggle}
          disabled={disabled}
          sx={{
            fontSize: "11px",
            fontFamily: "NotoSans-Medium",
            backgroundColor: primaryColor,
            color: "#ffffff",
            borderColor: primaryColor,
            "&:hover": {
              backgroundColor: alpha(primaryColor, 0.9),
              borderColor: primaryColor,
            },
            "&:active": {
              backgroundColor: alpha(primaryColor, 0.8),
            },
          }}
        >
          <GrSearchAdvanced style={{ padding: "2px", fontSize: "20px" }} />
          Add Item
        </Button>
        <Button
          variant="outlined"
          size="small"
          onClick={() => onSrchItemClicked(null)}
          disabled={disabled}
          sx={{
            fontSize: "11px",
            fontFamily: "NotoSans-Medium",
            color: primaryColor,
            borderColor: primaryColor,
            "&:hover": {
              backgroundColor: alpha(primaryColor, 0.04),
              borderColor: primaryColor,
            },
            "&:active": {
              backgroundColor: alpha(primaryColor, 0.08),
            },
          }}
        >
          <GrSearch style={{ padding: "2px", fontSize: "18px" }} />
          Edit Item
        </Button>
      </div>

      <StyledMenu
        id="split-button-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        {commercialProducts.map((option, index) => (
          <MenuItem
            key={option}
            onClick={(event) => handleMenuItemClick(event, index)}
          >
            {option}
          </MenuItem>
        ))}
      </StyledMenu>
    </>
  );
}
